import {Component, Vue, Watch} from 'vue-property-decorator'
import {menuBtn} from "@/utils/menu_level2_button";
import * as echarts from 'echarts';
import {formatDate} from "@/utils/timeFilter";
import {delNullProperty} from "@/utils";
import {getMarketCooperationContrast, getMarketCooperationPrevLevel} from '@/api/common';
import { getMarketCooperationContrastExport } from '@/api/market'

import {
    lastMonth,
    lastQuarter,
    lastWeek, lastYear,
    thisMonth,
    thisQuarter,
    thisToday,
    thisWeek, thisYear,
    thisYesterday
} from "@/utils/dateTime";

@Component({})
export default class CooperationStatisticsData extends Vue {
    loading = false
    dataFilter = 0
    page1 = 1
    page2 = 1
    page3 = 1
    total1 = 0
    total2 = 0
    total3 = 0
    data: any = []
    marketCooperationIdList = [] //渠道筛选
    firstTimeStr = [] //查询时间
    secondTimeStr = [] //对比时间
    cooperativePartnerList = []
    cooperativePartnerName = ''
    marketLevelPage = 1
    marketLevelSize = 20
    timeType = '1'
    timeStr = ''
    timeType1 = '1'
    timeStr1 = ''
    startWeek = '' // 本周开始
    endWeek = '' //本周结束
    startMonth = '' // 本月开始
    endMonth = ''  //本月结束
    startLastWeek = '' //上周开始
    endLastWeek = '' //上周结束
    startLastMonth = '' // 上月开始
    endLastMonth = ''  // 上月结束
    startQuarter = ''  // 本季度开始
    endQuarter = '' // 本季度结束
    startLastQuarter = '' //上季度开始
    endLastQuarter = '' //上季度结束
    startYear = '' // 本年开始
    endYear = '' // 本年结束
    timeStrDate = []
    today = ''
    yesterday = ''
    yesteryearStart = ''
    yesteryearEnd = ''
    timeStrDate1 = []
    option = null
    myChart = null
    exportBUttonDisabled = false
    buttonShow = menuBtn

    created() {
        this.getMarketChannelName()
        this.getDateInterval()
    }

    // 时间区间过滤器
    changeTime(val: Date[]): string {
        if (val == null) return ''
        let time = ''
        val.forEach((item: any) => {
            time += formatDate('yyyy-MM-dd', new Date(item)) + '&'
        })
        time = time.slice(0, time.length - 1)
        return time
    }
    async getMarketChannelName() {
        const data: any = await getMarketCooperationPrevLevel(
            {
                name: this.cooperativePartnerName,
                page: this.marketLevelPage,
                limit: this.marketLevelSize,
            }
        )
        this.cooperativePartnerList = [...this.cooperativePartnerList, ...data.marketCooperationList]
        const result = []
        const obj = {}
        for (let i = 0; i < this.cooperativePartnerList.length; i++) {
            if (!obj[this.cooperativePartnerList[i].id]) {
                result.push(this.cooperativePartnerList[i]);
                obj[this.cooperativePartnerList[i].id] = true;
            }
        }
        this.cooperativePartnerList = result
    }
    async remoteCooperativePartnerMethod(query: any) {
        this.cooperativePartnerName = query
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        if (query !== '') {
            const result: any = await getMarketCooperationPrevLevel({
                page: this.marketLevelPage,
                limit: this.marketLevelSize,
                name: query
            })
            this.cooperativePartnerList = result.marketCooperationList
        } else {
            this.cooperativePartnerList = []
            this.getMarketChannelName()
        }
    }
    clearCooperativePartner() {
        this.cooperativePartnerList = []
        this.marketCooperationIdList = []
        this.cooperativePartnerName = null
        this.marketLevelPage = 1
        this.marketLevelSize = 20
        this.getMarketChannelName()
    }
    changeCooperativePartner(val) {
        this.marketCooperationIdList = val
    }
    cooperativePartnerLoadmore() {
        this.marketLevelPage = 1
        this.marketLevelSize += 20
        this.getMarketChannelName();
    }
    /*重置*/
    handleReset() {
        this.marketCooperationIdList = []
        this.timeStr = ''
        this.timeStr1 = ''
        this.timeStrDate = []
        this.timeStrDate1 = []
        this.timeType = ''
        this.timeType1 = ''
        for (let i = 0; i < this.option.series.length; i++) {  //置空关键！！！  清空名字和数据
            this.option.series[i].data = []
            this.option.series[i].name = ''
        }
        const chartDom = document.getElementById('BarChartVisit');
        this.myChart = echarts.init(chartDom)  //再次初始化
        this.myChart.setOption(this.option, true)  //重新setOption
        // this.legendList = []  //清空之前
        // this.dataList = [] //清空之前
    }
    async getData() {
        if (this.marketCooperationIdList.length === 0) {
            this.$message.error('请至少选择一个渠道')
            return
        }
        if (!this.timeStr) {
            this.$message.error('请选择查询时间')
            return
        }
        if (!this.timeStr) {
            this.$message.error('请选择对比时间')
            return
        }
        this.loading = true
        const obj = {
            marketCooperationIdList: this.marketCooperationIdList,
            firstTimeStr: this.timeStr,
            secondTimeStr: this.timeStr1
        }
        const data: any = await getMarketCooperationContrast(obj)
        this.data = data.marketCooperationContrastList
        this.initBarChartVisit()
        setTimeout(() => {
            this.loading = false
        }, 2000);
    }
    // 顾问拜访频次统计图
    initBarChartVisit() {
        let data = []
        let arr = []
        arr = Object.keys(this.data[0])
        data = this.data
        const removedArr = arr.filter((x) => x !== "x");
        removedArr.unshift('x')
        const dimensions = removedArr
        const series = []
        for (let i = 0; i < dimensions.length; i++) {
            if (dimensions[i] !== 'x') {
                series.push({
                    type: 'bar',
                    yAxisIndex: 0,
                    barMinHeight: 3,
                    label: { show: true, position: 'top' },
                    // markLine: {
                    //     data: [{ type: 'average', name: 'Avg' }]
                    // }
                });
            }
        }
        const chartDom = document.getElementById('BarChartVisit');
        this.myChart = echarts.init(chartDom);
        this.option = {
            title: {
                subtext: '送生人数'
            },
            legend: {
                right: 5,

            },
            dataset: {
                dimensions: dimensions,
                source: data
            },
            tooltip: {
                trigger: 'item',
                show: true,
            },
            xAxis: {
                type: 'category',
                name: '时间区间',
                nameTextStyle: {
                    widht: 20,
                    padding: [0, 0, 0, 20]
                },
                triggerEvent: true,

            },
            yAxis: [
                {type: 'value', minInterval: 10, splitNumber: 10},

            ],
            series: series

        }
        this.option && this.myChart.setOption(this.option);
    }
    // 选择区间
    changeDateType(val) {
        if (val === '2') {  //    本周
            this.timeStr = this.startWeek + '&' + this.endWeek
            this.timeStrDate = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr = this.startMonth + '&' + this.endMonth
            this.timeStrDate = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr = this.startYear + '&' + this.endYear
            this.timeStrDate = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr = this.yesterday + '&' + this.yesterday
            this.timeStrDate = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
        } else {
            this.timeStr = ''
            this.timeStrDate = []
        }


        // if (this.timeStr) {
        //     this.getMarketChannelName()
        // }

    }

    handleChangeData(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType = '1'
        } else {
            this.timeType = '自定义时间'
        }
        this.timeStr = val[0] + '&' + val[1]
        // this.getMarketChannelName()
    }
    // 初始化获取日期区间
    getDateInterval() {
        // 获取今天
        this.today = thisToday();

        // 获取昨天
        this.yesterday = thisYesterday();

        // 本周
        this.startWeek = thisWeek()[0]//周一日期
        this.endWeek = thisWeek()[1];//周日日期

        //上周
        this.startLastWeek = lastWeek()[0]; //周一日期
        this.endLastWeek = lastWeek()[1]; //周日日期

        // 本月
        this.startMonth = thisMonth()[0]
        this.endMonth = thisMonth()[1]

        // 上月
        this.startLastMonth = lastMonth()[0];
        this.endLastMonth = lastMonth()[1];

        // 本季度
        this.startQuarter = thisQuarter()[0];
        this.endQuarter = thisQuarter()[1];

        // 上季度
        this.startLastQuarter = lastQuarter()[0];
        this.endLastQuarter = lastQuarter()[1];

        //本年
        this.startYear = thisYear()[0];
        this.endYear = thisYear()[1];

        // 获取去年
        this.yesteryearStart = lastYear()[0];
        this.yesteryearEnd = lastYear()[1];

        if (this.timeType == '1') {
            this.timeStr = this.today + '&' + this.today
            this.timeStrDate = [this.today, this.today]
            // this.getData()
        }
        if (this.timeType1 == '1') {
            this.timeStr1 = this.today + '&' + this.today
            this.timeStrDate1 = [this.today, this.today]
            // this.getData()
        }

    }
    // 选择区间
    changeDateType1(val) {
        if (val === '2') {  //    本周
            this.timeStr1 = this.startWeek + '&' + this.endWeek
            this.timeStrDate1 = [this.startWeek, this.endWeek]
        } else if (val === '3') { // 本月
            this.timeStr1 = this.startMonth + '&' + this.endMonth
            this.timeStrDate1 = [this.startMonth, this.endMonth]
        } else if (val === '4') { // 本季度
            this.timeStr1 = this.startQuarter + '&' + this.endQuarter
            this.timeStrDate1 = [this.startQuarter, this.endQuarter]
        } else if (val === '5') { // 本年
            this.timeStr1 = this.startYear + '&' + this.endYear
            this.timeStrDate1 = [this.startYear, this.endYear]
        } else if (val === '6') { // 上周
            this.timeStr1 = this.startLastWeek + '&' + this.endLastWeek
            this.timeStrDate1 = [this.startLastWeek, this.endLastWeek]
        } else if (val === '7') { // 上月
            this.timeStr1 = this.startLastMonth + '&' + this.endLastMonth
            this.timeStrDate1 = [this.startLastMonth, this.endLastMonth]
        } else if (val === '8') { // 上季度
            this.timeStr1 = this.startLastQuarter + '&' + this.endLastQuarter
            this.timeStrDate1 = [this.startLastQuarter, this.endLastQuarter]
        } else if (val === '9') { // 去年
            this.timeStr1 = this.yesteryearStart + '&' + this.yesteryearEnd
            this.timeStrDate1 = [this.yesteryearStart, this.yesteryearEnd]
        } else if (val === '0') { // 昨天
            this.timeStr1 = this.yesterday + '&' + this.yesterday
            this.timeStrDate1 = [this.yesterday, this.yesterday]
        } else if (val === '1') { // 今天
            this.timeStr1 = this.today + '&' + this.today
            this.timeStrDate1 = [this.today, this.today]
        } else {
            this.timeStr1 = ''
            this.timeStrDate1 = []
        }


        // if (this.timeStr) {
        //     this.getMarketChannelName()
        // }

    }
    handleChangeData1(val) {
        const week = [this.startWeek, this.endWeek]
        const month = [this.startMonth, this.endMonth]
        const year = [this.startYear, this.endYear]
        const quarter = [this.startQuarter, this.endQuarter]
        const lastWeek = [this.startLastWeek, this.endLastWeek]
        const lastMonth = [this.startLastMonth, this.endLastMonth]
        const lastQuarter = [this.startLastQuarter, this.endLastQuarter]
        const lastyear = [this.yesteryearStart, this.yesteryearEnd]
        const yesterday = [this.yesterday, this.yesterday]
        const today = [this.today, this.today]
        if (week[0].indexOf(val[0]) !== -1 && week[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '2'
        } else if (month[0].indexOf(val[0]) !== -1 && month[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '3'
        } else if (quarter[0].indexOf(val[0]) !== -1 && quarter[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '4'
        } else if (year[0].indexOf(val[0]) !== -1 && year[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '5'
        } else if (lastWeek[0].indexOf(val[0]) !== -1 && lastWeek[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '6'
        } else if (lastMonth[0].indexOf(val[0]) !== -1 && lastMonth[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '7'
        } else if (lastQuarter[0].indexOf(val[0]) !== -1 && lastQuarter[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '8'
        } else if (lastyear[0].indexOf(val[0]) !== -1 && lastyear[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '9'
        } else if (yesterday[0].indexOf(val[0]) !== -1 && yesterday[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '0'
        } else if (today[0].indexOf(val[0]) !== -1 && today[1].indexOf(val[1]) !== -1) {
            this.timeType1 = '1'
        } else {
            this.timeType1 = '自定义时间'
        }
        this.timeStr1 = val[0] + '&' + val[1]
        // this.getMarketChannelName()
    }
    // 导出
    async exportExcel() {
        this.exportBUttonDisabled = true
        this.$message.success('数据已转入后台导出, 请前往下载列表查看')
        const obj = { firstTimeStr: this.timeStr, secondTimeStr: this.timeStr1 }
        getMarketCooperationContrastExport(delNullProperty(obj)).then(() => {
            this.exportBUttonDisabled = false
        }).catch(() => {
            this.exportBUttonDisabled = false
        })
    }
    

    @Watch('data')
    handleWatchEcharts() {
        const chartDom = document.getElementById('BarChartVisit');
        this.myChart = echarts.init(chartDom);
        this.$nextTick(() => {
            this.option && this.myChart.setOption(this.option, true);
        })
    }
}
